module.exports = __webpack_public_path__ + "static/sem-d187c020f9e94167a4caacffc424b747.svg";